export default {
    init() {
        //Removed empty <p> nodes
        $('.entry-content p').each(function () {
            var p = $(this),
                txt = p.html();
            if (txt == '&nbsp;') {
                p.remove();
            }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js